<template>
  <Modal v-if="modal" class="PackagesDispatch__Modal" @close="close">
    <template #header>
      <div class="PackagesDispatch__Modal__Header">
        <span>Expedição de Romaneio</span>
      </div>
    </template>
    <template #body>
      <div class="PackagesDispatch__Modal__Body">
        <template v-if="step === 'barcode'">
          <svg
            class="PackagesDispatch__Modal__Barcode"
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns="http://www.w3.org/2000/svg"
            xml:space="preserve"
            style="enable-background:new 0 0 512 512;"
            viewBox="0 0 512 512"
            y="0px"
            x="0px"
            version="1.1"
          >
            <path
              id="code-area"
              d="M 42.667969 64 C 19.146969 64 0 83.135969 0 106.66797 L 0 138.66797 C 0 144.56397 4.7719688 149.33203 10.667969 149.33203 C 16.563969 149.33203 21.333984 144.56202 21.333984 138.66602 L 21.333984 106.66602 C 21.333984 94.906016 30.897969 85.332031 42.667969 85.332031 L 74.667969 85.332031 C 80.563969 85.332031 85.333984 80.562016 85.333984 74.666016 C 85.332984 68.771016 80.563969 64 74.667969 64 L 42.667969 64 z M 437.33203 64 C 431.43603 64 426.66602 68.771969 426.66602 74.667969 C 426.66602 80.563969 431.43603 85.333984 437.33203 85.333984 L 469.33203 85.333984 C 481.10303 85.333984 490.66602 94.907969 490.66602 106.66797 L 490.66602 138.66797 C 490.66602 144.56397 495.43603 149.33398 501.33203 149.33398 C 507.22803 149.33398 512 144.56397 512 138.66797 L 512 106.66797 C 512 83.135969 492.85303 64 469.33203 64 L 437.33203 64 z M 10.667969 362.66797 C 4.7719687 362.66797 1.1842379e-15 367.43703 0 373.33203 L 0 405.33203 C 0 428.86403 19.146969 448 42.667969 448 L 74.667969 448 C 80.563969 448 85.333984 443.22803 85.333984 437.33203 C 85.333984 431.43603 80.563969 426.66797 74.667969 426.66797 L 42.667969 426.66797 C 30.896969 426.66797 21.333984 417.09398 21.333984 405.33398 L 21.333984 373.33398 C 21.333984 367.43798 16.563969 362.66797 10.667969 362.66797 z M 501.33203 362.66797 C 495.43603 362.66797 490.66602 367.43798 490.66602 373.33398 L 490.66602 405.33398 C 490.66602 417.09398 481.10203 426.66797 469.33203 426.66797 L 437.33203 426.66797 C 431.43603 426.66797 426.66602 431.43798 426.66602 437.33398 C 426.66602 443.22998 431.43703 448 437.33203 448 L 469.33203 448 C 492.85303 448 512 428.86403 512 405.33203 L 512 373.33203 C 512 367.43703 507.22803 362.66797 501.33203 362.66797 z "
              style="fill:#303c42"
            />
            <path
              id="barcode"
              d="M 74.667969 128 C 68.771969 128 64 132.77197 64 138.66797 L 64 373.33398 C 64 379.22898 68.771969 384 74.667969 384 C 80.563969 384 85.333984 379.22803 85.333984 373.33203 L 85.333984 138.66797 C 85.332984 132.77197 80.563969 128 74.667969 128 z M 138.66797 128 C 132.77197 128 128 132.77197 128 138.66797 L 128 309.33398 C 128 315.22998 132.77197 320.00195 138.66797 320.00195 C 144.56397 320.00195 149.33398 315.22998 149.33398 309.33398 L 149.33398 138.66797 C 149.33298 132.77197 144.56397 128 138.66797 128 z M 181.33203 128 C 175.43603 128 170.66602 132.77197 170.66602 138.66797 L 170.66602 309.33398 C 170.66602 315.22998 175.43603 320.00195 181.33203 320.00195 C 187.22803 320.00195 192 315.22998 192 309.33398 L 192 138.66797 C 192 132.77197 187.22803 128 181.33203 128 z M 224 128 C 218.104 128 213.33203 132.77197 213.33203 138.66797 L 213.33203 309.33398 C 213.33203 315.22998 218.104 320.00195 224 320.00195 C 229.896 320.00195 234.66797 315.22998 234.66797 309.33398 L 234.66797 138.66797 C 234.66797 132.77197 229.896 128 224 128 z M 288 128 C 282.104 128 277.33203 132.77197 277.33203 138.66797 L 277.33203 373.33398 C 277.33203 379.22998 282.104 384.00195 288 384.00195 C 293.896 384.00195 298.66797 379.22998 298.66797 373.33398 L 298.66797 138.66797 C 298.66797 132.77197 293.896 128 288 128 z M 330.66797 128 C 324.77197 128 320 132.77197 320 138.66797 L 320 309.33398 C 320 315.22998 324.77197 320.00195 330.66797 320.00195 C 336.56397 320.00195 341.33398 315.22998 341.33398 309.33398 L 341.33398 138.66797 C 341.33298 132.77197 336.56397 128 330.66797 128 z M 394.66797 128 C 388.77197 128 384 132.77197 384 138.66797 L 384 309.33398 C 384 315.22998 388.77197 320.00195 394.66797 320.00195 C 400.56397 320.00195 405.33398 315.22998 405.33398 309.33398 L 405.33398 138.66797 C 405.33298 132.77197 400.56397 128 394.66797 128 z M 437.33203 128 C 431.43603 128 426.66602 132.77197 426.66602 138.66797 L 426.66602 373.33398 C 426.66602 379.22998 431.43603 384.00195 437.33203 384.00195 C 443.22803 384.00195 448 379.22803 448 373.33203 L 448 138.66797 C 448 132.77197 443.22803 128 437.33203 128 z M 138.66797 341.33203 C 132.77197 341.33203 128 346.104 128 352 L 128 373.33203 C 128 379.22803 132.77197 384 138.66797 384 C 144.56397 384 149.33398 379.22803 149.33398 373.33203 L 149.33398 352 C 149.33298 346.104 144.56397 341.33203 138.66797 341.33203 z M 181.33203 341.33203 C 175.43603 341.33203 170.66602 346.104 170.66602 352 L 170.66602 373.33203 C 170.66602 379.22803 175.43603 384 181.33203 384 C 187.22803 384 192 379.22803 192 373.33203 L 192 352 C 192 346.104 187.22803 341.33203 181.33203 341.33203 z M 224 341.33203 C 218.104 341.33203 213.33203 346.104 213.33203 352 L 213.33203 373.33203 C 213.33203 379.22803 218.104 384 224 384 C 229.896 384 234.66797 379.22803 234.66797 373.33203 L 234.66797 352 C 234.66797 346.104 229.896 341.33203 224 341.33203 z M 330.66797 341.33203 C 324.77197 341.33203 320 346.104 320 352 L 320 373.33203 C 320 379.22803 324.77197 384 330.66797 384 C 336.56397 384 341.33398 379.22803 341.33398 373.33203 L 341.33398 352 C 341.33298 346.104 336.56397 341.33203 330.66797 341.33203 z M 394.66797 341.33203 C 388.77197 341.33203 384 346.104 384 352 L 384 373.33203 C 384 379.22803 388.77197 384 394.66797 384 C 400.56397 384 405.33398 379.22803 405.33398 373.33203 L 405.33398 352 C 405.33298 346.104 400.56397 341.33203 394.66797 341.33203 z "
              style="fill:#303c42"
            />
            <path
              id="read-line"
              d="M 501.333,210.63434 H 10.667 c -5.896,0 -10.667,4.771 -10.667,10.666 0,5.896 4.771,10.667 10.667,10.667 h 490.667 c 5.896,0 10.667,-4.771 10.667,-10.667 -10e-4,-5.895 -4.772,-10.666 -10.668,-10.666 z"
              style="fill:#d32f2f"
            />
          </svg>
          <p>
            <small>
              Utilize o bipador para ler o código de barras na gaiola do romaneio<br>
              a ser expedido ou insira manualmente clicando no botão abaixo.
            </small>
          </p>
          <div class="PackagesDispatch__Modal__Buttons">
            <BaseButton
              filled
              color="dark"
              text-color="white"
              label="Inserir código manualmente"
              @click="step = 'manual'; code = null"
            />
          </div>
        </template>
        <template v-else-if="step === 'manual'">
          <p>Insira o código do romaneio a ser expedido:</p>
          <InputGroup
            v-model="code"
            class="PackagesDispatch__Modal__Input"
            label="Código do romaneio"
            placeholder="Digite aqui"
            autocomplete="no"
          />
          <div class="PackagesDispatch__Modal__Buttons">
            <BaseButton
              filled
              color="dark"
              text-color="white"
              label="Voltar"
              @click="step = 'barcode'"
            />
            <BaseButton
              filled
              color="dark"
              text-color="white"
              label="Confirmar"
              @click="checkIfPackagesListExists(code)"
            />
          </div>
        </template>
        <template v-else-if="step === 'notFound'">
          <p>
            Nenhum romaneio encontrado.<br>
            Você também pode inserir manualmente clicando no botão abaixo.
          </p>
          <div class="PackagesDispatch__Modal__Buttons">
            <BaseButton
              filled
              color="dark"
              text-color="white"
              label="Inserir código manualmente"
              @click="step = 'manual'; code = null"
            />
          </div>
        </template>
        <template v-else-if="step === 'confirm'">
          <p><strong>Código do Romaneio: {{ code }}</strong></p>
          <p>{{ getUser().name }}, confirma a expedição do romaneio de código {{ code }} na data de {{ dateNow }}</p>
          <div class="PackagesDispatch__Modal__Buttons">
            <BaseButton
              filled
              color="dark"
              text-color="white"
              label="Cancelar"
              @click="modal = false"
            />
            <BaseButton
              filled
              color="dark"
              text-color="white"
              label="Confirmar"
              @click="confirm"
            />
          </div>
        </template>
      </div>
    </template>
  </Modal>
</template>
<script>
import { mapActions } from 'vuex'
import { BaseButton } from '@/components/atoms'
import { Modal, InputGroup } from '@/components/molecules'
import barCodeScannerMixin from '@/mixins/barCodeScanner'
import Mask from '@/plugins/mask/Mask.js'
import { packages } from '@/api'

export default {
  name: 'PackagesDispatch',
  components: {
    BaseButton,
    Modal,
    InputGroup
  },
  mixins: [barCodeScannerMixin],
  data() {
    return {
      modal: false,
      step: 'barcode',
      code: null,
      dateNow: 0
    }
  },
  mounted () {
    this.updateNow()
    setInterval(this.updateNow.bind(this) , 1000)
  },
  methods: {
    ...mapActions({
      setLoading: 'loading/setLoading',
    }),

    getUser(){
      return localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))  : ''
    },

    updateNow() {
      this.dateNow = Mask.millisecondsToDateHour(Date.now())
    },

    onCodeSliced(code) {
      if (this.step === 'barcode' && this.modal) {
        this.checkIfPackagesListExists(code)
      }
    },

    async checkIfPackagesListExists(code) {
      this.code = code
      this.setLoading(true)
      await packages.checkIfPackagesListExists(code, (r) => {
        if (r.length > 0) {
          if (r[0] === null) {
            this.step = 'notFound'
          } else {
            this.step = 'confirm'
          }
        } else {
          this.step = 'notFound'
        }
      }, (e) => e, () => this.setLoading(false))
    },

    open() {
      this.modal = true
      this.step = 'barcode'
      this.$emit('open')
    },

    close() {
      this.modal = false
      this.$emit('close')
    },

    async confirm() {
      this.setLoading(true)
      await packages.confirmPackagesDispatch({
        romaneio_id: this.code
      }, () => {
        this.modal = false
        this.$emit('confirm')
      }, (e) => e, () => this.setLoading(false))
    },

  }
}
</script>
<style lang="scss" scoped>
.PackagesDispatch {

  &__Content {
    margin-bottom: 5rem;
    p {
      margin-bottom: 1rem;
      font-weight: 500;
    }
  }

  &__Modal {

    /deep/ .Modal__container {
      width: calc(100% - 30px);
      max-width: 550px;
      height: auto;
      max-height: 90vh;
    }

    &__Header {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      span {
        font-weight: 500;
        padding-left: 10px;
      }
    }

    &__Body {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: 100%;
      padding: 1.5rem 1.5rem;

      p {
        text-align: center;
        margin-bottom: 1.5rem;
      }
    }

    &__Input {
      margin-bottom: 1.5rem;
    }

    &__Buttons {
      display: flex;
      gap: 1rem;
    }

    &__Barcode {
      width: 100%;
      max-width: 300px;
      margin: 0 auto;
    }

  }
}

#read-line{
   animation: move 2s linear infinite;
}
#code-area{
 animation: fade 1s linear infinite;
}
@keyframes fade {
  0, 100% {
    opacity: 1
  }
  50% {
    opacity: 0
  }
}
@keyframes move  {
   0%, 100%{
    transform: translateY(-5%)
  }
  50% {
    transform: translateY(15%)
  }
}
</style>
